"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "OrgUsersController", {
    enumerable: true,
    get: function() {
        return OrgUsersController;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _orgusersservice = require("src/services/org-users.service");
const _globalguard = require("~/guards/global/global.guard");
const _PagedResponse = require("~/helpers/PagedResponse");
const _models = require("~/models");
const _extractidsmiddleware = require("~/middlewares/extract-ids/extract-ids.middleware");
const _metaapilimiterguard = require("~/guards/meta-api-limiter.guard");
const _config = require("~/interface/config");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
let OrgUsersController = class OrgUsersController {
    async userList(req) {
        return new _PagedResponse.PagedResponseImpl(await this.orgUsersService.userList({
            query: req.query
        }), _extends({}, req.query, {
            // todo: fix - wrong count
            count: await _models.User.count(req.query)
        }));
    }
    async userUpdate(body, userId, req) {
        return await this.orgUsersService.userUpdate({
            user: body,
            userId,
            req
        });
    }
    async userDelete(userId) {
        await this.orgUsersService.userDelete({
            userId
        });
        return {
            msg: 'The user has been deleted successfully'
        };
    }
    async userAdd(body, req) {
        const result = await this.orgUsersService.userAdd({
            user: req.body,
            req
        });
        return result;
    }
    async userSettings(body) {
        await this.orgUsersService.userSettings(body);
        return {};
    }
    async userInviteResend(req, userId) {
        await this.orgUsersService.userInviteResend({
            userId,
            req
        });
        return {
            msg: 'The invitation has been sent to the user'
        };
    }
    async generateResetUrl(req, userId) {
        const result = await this.orgUsersService.generateResetUrl({
            siteUrl: req.ncSiteUrl,
            userId
        });
        return result;
    }
    async appSettingsGet() {
        const settings = await this.orgUsersService.appSettingsGet();
        return settings;
    }
    async appSettingsSet(body) {
        await this.orgUsersService.appSettingsSet({
            settings: body
        });
        return {
            msg: 'The app settings have been saved'
        };
    }
    constructor(orgUsersService){
        this.orgUsersService = orgUsersService;
    }
};
_ts_decorate([
    (0, _common.Get)('/api/v1/users'),
    (0, _extractidsmiddleware.Acl)('userList', {
        scope: 'org',
        allowedRoles: [
            _nocodbsdk.OrgUserRoles.SUPER_ADMIN
        ],
        blockApiTokenAccess: true
    }),
    _ts_param(0, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], OrgUsersController.prototype, "userList", null);
_ts_decorate([
    (0, _common.Patch)('/api/v1/users/:userId'),
    (0, _extractidsmiddleware.Acl)('userUpdate', {
        scope: 'org',
        allowedRoles: [
            _nocodbsdk.OrgUserRoles.SUPER_ADMIN
        ],
        blockApiTokenAccess: true
    }),
    _ts_param(0, (0, _common.Body)()),
    _ts_param(1, (0, _common.Param)('userId')),
    _ts_param(2, (0, _common.Request)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        void 0,
        String,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], OrgUsersController.prototype, "userUpdate", null);
_ts_decorate([
    (0, _common.Delete)('/api/v1/users/:userId'),
    (0, _extractidsmiddleware.Acl)('userDelete', {
        scope: 'org',
        allowedRoles: [
            _nocodbsdk.OrgUserRoles.SUPER_ADMIN
        ],
        blockApiTokenAccess: true
    }),
    _ts_param(0, (0, _common.Param)('userId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], OrgUsersController.prototype, "userDelete", null);
_ts_decorate([
    (0, _common.Post)('/api/v1/users'),
    (0, _common.HttpCode)(200),
    (0, _extractidsmiddleware.Acl)('userAdd', {
        scope: 'org',
        allowedRoles: [
            _nocodbsdk.OrgUserRoles.SUPER_ADMIN
        ],
        blockApiTokenAccess: true
    }),
    _ts_param(0, (0, _common.Body)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        void 0,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], OrgUsersController.prototype, "userAdd", null);
_ts_decorate([
    (0, _common.Post)('/api/v1/users/settings'),
    (0, _common.HttpCode)(200),
    (0, _extractidsmiddleware.Acl)('userSettings', {
        scope: 'org',
        allowedRoles: [
            _nocodbsdk.OrgUserRoles.SUPER_ADMIN
        ],
        blockApiTokenAccess: true
    }),
    _ts_param(0, (0, _common.Body)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        void 0
    ]),
    _ts_metadata("design:returntype", Promise)
], OrgUsersController.prototype, "userSettings", null);
_ts_decorate([
    (0, _common.Post)('/api/v1/users/:userId/resend-invite'),
    (0, _common.HttpCode)(200),
    (0, _extractidsmiddleware.Acl)('userInviteResend', {
        scope: 'org',
        allowedRoles: [
            _nocodbsdk.OrgUserRoles.SUPER_ADMIN
        ],
        blockApiTokenAccess: true
    }),
    _ts_param(0, (0, _common.Req)()),
    _ts_param(1, (0, _common.Param)('userId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], OrgUsersController.prototype, "userInviteResend", null);
_ts_decorate([
    (0, _common.Post)('/api/v1/users/:userId/generate-reset-url'),
    (0, _common.HttpCode)(200),
    (0, _extractidsmiddleware.Acl)('generateResetUrl', {
        scope: 'org',
        allowedRoles: [
            _nocodbsdk.OrgUserRoles.SUPER_ADMIN
        ],
        blockApiTokenAccess: true
    }),
    _ts_param(0, (0, _common.Req)()),
    _ts_param(1, (0, _common.Param)('userId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], OrgUsersController.prototype, "generateResetUrl", null);
_ts_decorate([
    (0, _common.Get)('/api/v1/app-settings'),
    (0, _extractidsmiddleware.Acl)('appSettingsGet', {
        scope: 'org',
        allowedRoles: [
            _nocodbsdk.OrgUserRoles.SUPER_ADMIN
        ],
        blockApiTokenAccess: true
    }),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", []),
    _ts_metadata("design:returntype", Promise)
], OrgUsersController.prototype, "appSettingsGet", null);
_ts_decorate([
    (0, _common.Post)('/api/v1/app-settings'),
    (0, _common.HttpCode)(200),
    (0, _extractidsmiddleware.Acl)('appSettingsSet', {
        scope: 'org',
        allowedRoles: [
            _nocodbsdk.OrgUserRoles.SUPER_ADMIN
        ],
        blockApiTokenAccess: true
    }),
    _ts_param(0, (0, _common.Body)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        void 0
    ]),
    _ts_metadata("design:returntype", Promise)
], OrgUsersController.prototype, "appSettingsSet", null);
OrgUsersController = _ts_decorate([
    (0, _common.Controller)(),
    (0, _common.UseGuards)(_metaapilimiterguard.MetaApiLimiterGuard, _globalguard.GlobalGuard),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _orgusersservice.OrgUsersService === "undefined" ? Object : _orgusersservice.OrgUsersService
    ])
], OrgUsersController);
